import { clsx } from "clsx";
import {
  type ComponentProps,
  type ForwardedRef,
  forwardRef,
  type ReactNode,
} from "react";

interface EmptyPlaceholderProps extends ComponentProps<"div"> {
  title: string;
  subtitle: string;
  imageSrc: string;
  actionComponent?: ReactNode;
}

function EmptyPlaceholder(
  {
    className,
    title,
    subtitle,
    actionComponent = null,
    imageSrc,
    ...props
  }: EmptyPlaceholderProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      className={clsx(
        "max-w-[364px] flex gap-y-4 flex-col mx-auto items-center grow justify-center",
        className,
      )}
      {...props}
    >
      <img src={imageSrc} alt={title} width={364} height={254} />

      <div className="flex flex-col items-center gap-y-2">
        <h5 className="text-center text-xl-bold">{title}</h5>
        <p className="text-sm text-pretty break-words text-center text-black-500">
          {subtitle}
        </p>
      </div>

      {actionComponent}
    </div>
  );
}
EmptyPlaceholder.displayName = "EmptyPlaceholder";

export default forwardRef(EmptyPlaceholder);
